var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9f07ca9f1f5ddaf94b7da92ed71748c1c84836da"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mojedrazbecom@100kvadratov-doo"]={id:"9f07ca9f1f5ddaf94b7da92ed71748c1c84836da"};
      